module.exports = __webpack_public_path__ + "static/blog56-872a74626a958416a251b3e89d91407e.png";